module.exports = __webpack_public_path__ + "media/images/partner/pic_4@2x-2442c6a6e33658f673c4cd64ee8b0ce1.png";